import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle",
  "data-kt-place": "true",
  "data-kt-place-mode": "prepend",
  "data-kt-place-parent": "{default: '#kt_body', lg: '#kt_header_nav'}"
}
const _hoisted_2 = {
  class: "menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item me-lg-1"
}
const _hoisted_4 = { class: "menu-title" }
const _hoisted_5 = {
  key: 1,
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_6 = { class: "menu-title" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_8 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" }
const _hoisted_9 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_10 = { class: "menu-icon" }
const _hoisted_11 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_12 = { class: "menu-title" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_14 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_15 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_17 = { class: "menu-title" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_19 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_21 = { class: "menu-title" }
const _hoisted_22 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_24 = { class: "menu-title" }
const _hoisted_25 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_26 = { class: "menu-icon" }
const _hoisted_27 = { class: "svg-icon svg-icon-2" }
const _hoisted_28 = { class: "menu-title" }
const _hoisted_29 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_30 = { class: "menu-link py-3" }
const _hoisted_31 = { class: "menu-title" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_33 = {
  class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown w-100 w-lg-600px p-5 p-lg-5",
  style: {}
}
const _hoisted_34 = {
  class: "row",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_35 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_36 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_37 = { class: "menu-item" }
const _hoisted_38 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_40 = { class: "menu-title" }
const _hoisted_41 = { class: "menu-item" }
const _hoisted_42 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_44 = { class: "menu-title" }
const _hoisted_45 = { class: "menu-item" }
const _hoisted_46 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_48 = { class: "menu-title" }
const _hoisted_49 = { class: "menu-item" }
const _hoisted_50 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_52 = { class: "menu-title" }
const _hoisted_53 = { class: "menu-item" }
const _hoisted_54 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_56 = { class: "menu-title" }
const _hoisted_57 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_58 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_59 = { class: "menu-item" }
const _hoisted_60 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_62 = { class: "menu-title" }
const _hoisted_63 = { class: "menu-item" }
const _hoisted_64 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_66 = { class: "menu-title" }
const _hoisted_67 = { class: "menu-item" }
const _hoisted_68 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_70 = { class: "menu-title" }
const _hoisted_71 = { class: "menu-item" }
const _hoisted_72 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_74 = { class: "menu-title" }
const _hoisted_75 = { class: "menu-item" }
const _hoisted_76 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_78 = { class: "menu-title" }
const _hoisted_79 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_80 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_81 = { class: "menu-item" }
const _hoisted_82 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_84 = { class: "menu-title" }
const _hoisted_85 = { class: "menu-item" }
const _hoisted_86 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_88 = { class: "menu-title" }
const _hoisted_89 = { class: "menu-item" }
const _hoisted_90 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_91 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_92 = { class: "menu-title" }
const _hoisted_93 = { class: "menu-item" }
const _hoisted_94 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_95 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_96 = { class: "menu-title" }
const _hoisted_97 = { class: "menu-item" }
const _hoisted_98 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_100 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
        return (_openBlock(), _createBlock(_Fragment, { key: i }, [
          (!item.heading)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                  (menuItem.heading)
                    ? (_openBlock(), _createBlock("div", _hoisted_3, [
                        _createVNode(_component_router_link, {
                          to: menuItem.route
                        }, {
                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                            _createVNode("a", {
                              href: href,
                              class: ["menu-link py-3", [isActive && 'active', isExactActive && 'active']],
                              onClick: navigate
                            }, [
                              _createVNode("span", _hoisted_4, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                            ], 10, ["href", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (item.heading)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("span", {
                  class: ["menu-link py-3", { active: _ctx.hasActiveChildren(item.route) }]
                }, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.translate(item.heading)), 1),
                  _hoisted_7
                ], 2),
                _createVNode("div", _hoisted_8, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                    return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                      (menuItem.sectionTitle)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            _createVNode("span", {
                              class: ["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem.route) }]
                            }, [
                              _createVNode("span", _hoisted_10, [
                                (_ctx.headerMenuIcons === 'font')
                                  ? (_openBlock(), _createBlock("i", {
                                      key: 0,
                                      class: [menuItem.fontIcon, "bi fs-3"]
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                (_ctx.headerMenuIcons === 'svg')
                                  ? (_openBlock(), _createBlock("span", _hoisted_11, [
                                      _createVNode(_component_inline_svg, {
                                        src: menuItem.svgIcon
                                      }, null, 8, ["src"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                              _hoisted_13
                            ], 2),
                            _createVNode("div", _hoisted_14, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem.sub, (menuItem1, k) => {
                                return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                                  (menuItem1.sectionTitle)
                                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                        _createVNode("span", {
                                          class: ["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem1.route) }]
                                        }, [
                                          _hoisted_16,
                                          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.translate(menuItem1.sectionTitle)), 1),
                                          _hoisted_18
                                        ], 2),
                                        _createVNode("div", _hoisted_19, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem1.sub, (menuItem2, l) => {
                                            return (_openBlock(), _createBlock("div", {
                                              key: l,
                                              class: "menu-item"
                                            }, [
                                              _createVNode(_component_router_link, {
                                                class: "menu-link py-3",
                                                "active-class": "active",
                                                to: menuItem2.route
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_20,
                                                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.translate(menuItem2.heading)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (menuItem1.heading)
                                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                                        _createVNode(_component_router_link, {
                                          class: "menu-link py-3",
                                          to: menuItem1.route
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_23,
                                            _createVNode("span", _hoisted_24, _toDisplayString(_ctx.translate(menuItem1.heading)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (menuItem.heading)
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            _createVNode(_component_router_link, {
                              class: "menu-link py-3",
                              to: menuItem.route
                            }, {
                              default: _withCtx(() => [
                                _createVNode("span", _hoisted_26, [
                                  _createVNode("span", _hoisted_27, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-arrange.svg" })
                                  ])
                                ]),
                                _createVNode("span", _hoisted_28, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createVNode("div", _hoisted_29, [
        _createVNode("span", _hoisted_30, [
          _createVNode("span", _hoisted_31, _toDisplayString(_ctx.translate("megaMenu")), 1),
          _hoisted_32
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, [
                  _createVNode("a", _hoisted_38, [
                    _hoisted_39,
                    _createVNode("span", _hoisted_40, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_41, [
                  _createVNode("a", _hoisted_42, [
                    _hoisted_43,
                    _createVNode("span", _hoisted_44, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("a", _hoisted_46, [
                    _hoisted_47,
                    _createVNode("span", _hoisted_48, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_49, [
                  _createVNode("a", _hoisted_50, [
                    _hoisted_51,
                    _createVNode("span", _hoisted_52, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("a", _hoisted_54, [
                    _hoisted_55,
                    _createVNode("span", _hoisted_56, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_57, [
              _createVNode("div", _hoisted_58, [
                _createVNode("div", _hoisted_59, [
                  _createVNode("a", _hoisted_60, [
                    _hoisted_61,
                    _createVNode("span", _hoisted_62, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_63, [
                  _createVNode("a", _hoisted_64, [
                    _hoisted_65,
                    _createVNode("span", _hoisted_66, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_67, [
                  _createVNode("a", _hoisted_68, [
                    _hoisted_69,
                    _createVNode("span", _hoisted_70, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_71, [
                  _createVNode("a", _hoisted_72, [
                    _hoisted_73,
                    _createVNode("span", _hoisted_74, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_75, [
                  _createVNode("a", _hoisted_76, [
                    _hoisted_77,
                    _createVNode("span", _hoisted_78, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_79, [
              _createVNode("div", _hoisted_80, [
                _createVNode("div", _hoisted_81, [
                  _createVNode("a", _hoisted_82, [
                    _hoisted_83,
                    _createVNode("span", _hoisted_84, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_85, [
                  _createVNode("a", _hoisted_86, [
                    _hoisted_87,
                    _createVNode("span", _hoisted_88, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_89, [
                  _createVNode("a", _hoisted_90, [
                    _hoisted_91,
                    _createVNode("span", _hoisted_92, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_93, [
                  _createVNode("a", _hoisted_94, [
                    _hoisted_95,
                    _createVNode("span", _hoisted_96, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_97, [
                  _createVNode("a", _hoisted_98, [
                    _hoisted_99,
                    _createVNode("span", _hoisted_100, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}